import ListActionModule from "./listAction/listAction.module";
import titlizeModule from "./titlize/titlize.module";
import roundModule from "./round/round.module";
import absPriceModule from "./absPrice/absPrice.module";
import dateFormatModule from "./dateFormat/dateFormat.module";
import trimModule from "./trim/trim.module";
import durationModule from "./duration/duration.module";
import numeralModule from "./numeral/numeral.module";
import routeName from "./routeName/routeName.module";

const filtersModule = angular.module("app.filters", [
  ListActionModule.name,
  titlizeModule.name,
  roundModule.name,
  absPriceModule.name,
  dateFormatModule.name,
  trimModule.name,
  durationModule.name,
  numeralModule.name,
  routeName.name,
]);

export default filtersModule;



// WEBPACK FOOTER //
// ./src/filters/index.js